import { Smartphone, X } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const APP_STORE_URL = 'https://apps.apple.com/us/app/mindy-app/id6743858683';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.quadminds.mindy';

export const MobileAppBanner = () => {
    const { t } = useTranslation();
    const [dismissed, setDismissed] = useState(false);

    if (dismissed) return null;

    const handleDismiss = () => {
        setDismissed(true);
    };

    return (
        <div className="flex items-center gap-3 w-full rounded-lg border border-tertiary-qm-100 dark:border-border bg-tertiary-qm-50 dark:bg-muted/40 px-4 py-3 mb-4">
            <Smartphone className="h-5 w-5 text-tertiary-qm-600 dark:text-tertiary-qm-300 flex-shrink-0" />
            <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">{t('mobileBanner.title')}</p>
                <p className="text-xs text-muted-foreground">{t('mobileBanner.subtitle')}</p>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
                <a
                    href={APP_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs font-medium text-tertiary-qm-600 dark:text-tertiary-qm-300 hover:underline"
                >
                    App Store
                </a>
                <a
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs font-medium text-tertiary-qm-600 dark:text-tertiary-qm-300 hover:underline"
                >
                    Google Play
                </a>
            </div>
            <button
                type="button"
                onClick={handleDismiss}
                aria-label={t('mobileBanner.close')}
                className="text-muted-foreground hover:text-foreground flex-shrink-0"
            >
                <X className="h-4 w-4" />
            </button>
        </div>
    );
};

export default MobileAppBanner;
